const mapArea = [
  {
    width: "8.481262327416173%",
    height: "2.7576197387518144%",
    left: "18.612001257300143%",
    top: "20.537513987592412%",
    url: "/img/map/인천.png",
    name: "인천",
  },
  {
    width: "5.9171597633136095%",
    height: "2.8301886792452833%",
    left: "29.65736614881888%",
    top: "20.464945047098944%",
    name: "서울",
    url: "/img/map/서울.png",
  },
  {
    width: "9.368836291913215%",
    height: "3.991291727140784%",
    left: "35.475906582743924%",
    top: "24.528805714733195%",
    name: "경기",
    url: "/img/map/경기.png",
  },
  {
    width: "7.6923076923076925%",
    height: "3.991291727140784%",
    left: "59.63764228294117%",
    top: "18.360445772788346%",
    name: "강원",
    url: "/img/map/강원.png",
  },
  {
    width: "6.31163708086785%",
    height: "2.7576197387518144%",
    left: "32.91180401864137%",
    top: "40.42140368280286%",
    name: "세종",
    url: "/img/map/세종.png",
  },
  {
    width: "6.903353057199212%",
    height: "2.6124818577648767%",
    left: "23.04987107978535%",
    top: "41.07452414724408%",
    name: "충청남도",
    url: "/img/map/충남.png",
  },
  {
    width: "6.41025641025641%",
    height: "2.8301886792452833%",
    left: "43.26683360444018%",
    top: "37.95405970602492%",
    name: "충청북도",
    url: "/img/map/충북.png",
  },
  {
    width: "6.607495069033531%",
    height: "3.0478955007256894%",
    left: "35.27866792396681%",
    top: "45.79150527931956%",
    name: "대전",
    url: "/img/map/대전.png",
  },
  {
    width: "7.297830374753452%",
    height: "3.265602322206096%",
    left: "65.94927936380903%",
    top: "46.880039386721585%",
    name: "경상북도",
    url: "/img/map/경북.png",
  },
  {
    width: "7.001972386587771%",
    height: "3.3381712626995643%",
    left: "29.65736614881888%",
    top: "56.7494164011475%",
    name: "전라북도",
    url: "/img/map/전북.png",
  },
  {
    width: "5.9171597633136095%",
    height: "2.6850507982583456%",
    left: "60.52521624743821%",
    top: "57.765381568056064%",
    name: "대구",
    url: "/img/map/대구.png",
  },
  {
    width: "7.988165680473373%",
    height: "3.483309143686502%",
    left: "52.6356698963534%",
    top: "65.96567184381803%",
    name: "경상남도",
    url: "/img/map/경남.png",
  },
  {
    width: "6.31163708086785%",
    height: "2.9753265602322205%",
    left: "75.9098316320536%",
    top: "63.93374151000091%",
    name: "울산",
    url: "/img/map/울산.png",
  },
  {
    width: "7.396449704142012%",
    height: "3.0478955007256894%",
    left: "70.88024583323703%",
    top: "70.39237721391963%",
    name: "부산",
    url: "/img/map/부산.png",
  },
  {
    width: "6.903353057199212%",
    height: "2.8301886792452833%",
    left: "19.696813880574304%",
    top: "68.79586052306331%",
    name: "광주",
    url: "/img/map/광주.png",
  },
  {
    width: "6.508875739644971%",
    height: "2.9753265602322205%",
    left: "18.907859245465822%",
    top: "75.47220304846245%",
    name: "전라남도",
    url: "/img/map/전남.png",
  },
  {
    width: "6.31163708086785%",
    height: "3.1204644412191582%",
    left: "26.205689620219275%",
    top: "94.12242075528393%",
    name: "제주",
    url: "/img/map/제주.png",
  },
];

export default mapArea;
